




















































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import FormNavigationButtons from '../common/FormNavigationButtons.vue';
import { Prop } from 'vue-property-decorator';
import {
    setLongFormatDate,
    getFullDate,
} from '@/modules/shared/shared/domain/functions/date-functions';
import * as FORM_INTERFACE from '../interfaces/accessTicket.interface';
import stringIsUndefined from '../utils/stringIsUndefined';
import { FormToPDT } from '../utils/form-to-PDT-mapping';
import { tickets } from '@/modules/shared/shared/store/namespaces';
import { SET_TICKET_DETAIL } from '@/modules/tickets/shared/store/tickets.mutations';
@Component({
    components: {
        FormNavigationButtons,
    },
    methods: {
        stringIsUndefined,
        setLongFormatDate,
        getFullDate,
    },
})
export default class StepAccessTicketConfirmation extends Vue {
    @Prop({
        default: function() {
            return {} as FORM_INTERFACE.accessTicketInterface;
        },
    })
    accessTicket!: FORM_INTERFACE.accessTicketInterface;

    @Prop({ default: {} })
    formValues!: {
        dataCenters: {
            value: number;
            text: string;
        }[];
        reasons: {
            value: number;
            text: string;
        }[];
        motives: {
            value: number;
            text: string;
        }[];
    };

    @Prop({ default: false })
    requiresHardware!: boolean;

    creatingTicket: boolean = false;

    isFormValid: boolean = true;
    $refs!: {
        form: any;
    };

    validateStep() {
        if (this.$refs.form.validate()) {
            this.$emit('nextStep');
        }
    }

    sendAccessTicket() {
        this.$emit('sendAccessTicket');
    }

    previousStep() {
        this.$emit('previousStep');
    }

    reset() {
        this.$emit('reset');
    }

    openPDT() {
        let headquartersName: string = '';
        this.formValues.dataCenters.forEach(dataCenter => {
            if (dataCenter.value == this.accessTicket.generalInformation.headquarters) {
                headquartersName = dataCenter.text;
            }
        });
        this.SET_TICKET_DETAIL(FormToPDT(this.accessTicket, headquartersName));
        let to = { name: 'pdt' };
        let routeData = this.$router.resolve(to);
        window.open(routeData.href, '_blank');
    }

    openEquipmentSheet() {
        let headquartersName: string = '';
        this.formValues.dataCenters.forEach(dataCenter => {
            if (dataCenter.value == this.accessTicket.generalInformation.headquarters) {
                headquartersName = dataCenter.text;
            }
        });
        this.SET_TICKET_DETAIL(FormToPDT(this.accessTicket, headquartersName));
        let to = { name: 'equipment-sheet' };
        let routeData = this.$router.resolve(to);
        window.open(routeData.href, '_blank');
    }

    textForAllValues(ids: number[], propery: string) {
        let fullText: string = '';
        if (ids != undefined) {
            ids.forEach(id => {
                fullText += this.textForValue(id, 'reasons');
                fullText += ', ';
            });
            return fullText.slice(0, -2);
        }
        return '';
    }

    textForValue(id: number, property: string) {
        let text = '';
        this.formValues[property].forEach(element => {
            element.value == id ? (text = element.text) : null;
        });
        return text;
    }

    formatTime(time: string) {
        if (time != '' && time != undefined) {
            let timeSegments: string[] = time.split(':');
            let midday: string = '';
            let hours: number = parseInt(timeSegments[0]);
            if (hours < 12) {
                midday = 'AM';
            } else {
                hours -= 12;
                midday = 'PM';
            }
            hours == 0 ? (hours = 12) : null;
            return hours.toString() + ':' + timeSegments[1] + midday;
        }
    }

    getLength(str: string | undefined) {
        if (str == undefined) {
            return 0;
        } else {
            return str.length;
        }
    }

    get hasDepartingEquipments() {
        return this.accessTicket.hardwareTransfer.some(
            item => item.transferInformation.movementType.id == 2,
        );
    }

    get getClientTasks() {
        if (this.accessTicket.tasks.length === undefined) {
            return Array();
        } else {
            return this.accessTicket.tasks.filter(task => task.person == 2);
        }
    }

    get getDaycoTasks() {
        if (this.accessTicket.tasks.length === undefined) {
            return Array();
        } else {
            return this.accessTicket.tasks.filter(task => task.person == 1);
        }
    }

    @tickets.Mutation(SET_TICKET_DETAIL) SET_TICKET_DETAIL;
}
